import React from 'react';
import { string } from 'prop-types';

import { ReportStatusTypes } from "./reportStatusTypes";
import './reportStatus.css';

const ReportStatus = ({className, status}) => {
	return (
		<div className={`cp-report-status status-${status} ${className}`}>
			{
				status === ReportStatusTypes.INIT &&
					<i className='fa fa-circle'/>
			}
			{
				status === ReportStatusTypes.RUNNING &&
				<i className='fa fa-spinner fa-spin fa-pulse'/>
			}
			{
				status === ReportStatusTypes.ERROR &&
				<i className='fa fa-exclamation-triangle'/>
			}
			{
				status === ReportStatusTypes.SUCCESS &&
				<i className='fa fa-check'/>
			}

		</div>
	);

};

ReportStatus.propTypes = {
	className: string,
	status: string.isRequired,
};

export default ReportStatus;


// WEBPACK FOOTER //
// ./src/views/components/report_status/ReportStatus.jsx